<template>
  <div class="page" :class="pageSizeClass">
    <!-- 상단: 임원 정보 섹션 -->
    <div class="committee-section">
      <h1 class="society-title">국제한국어응용언어학회</h1>

      <div class="committee-table">
        <div class="committee-row" v-if="infoData.advisor">
          <div class="committee-label">고문</div>
          <div class="committee-value">{{ infoData.advisor }}</div>
        </div>

        <div class="committee-row" v-if="infoData.advisory_committee">
          <div class="committee-label">자문위원</div>
          <div class="committee-value">{{ infoData.advisory_committee }}</div>
        </div>

        <div class="committee-row" v-if="infoData.president">
          <div class="committee-label">회장</div>
          <div class="committee-value">{{ infoData.president }}</div>
        </div>

        <div class="committee-row" v-if="infoData.vice_president">
          <div class="committee-label">부회장</div>
          <div class="committee-value">{{ infoData.vice_president }}</div>
        </div>

        <div class="committee-row mt-3" v-if="infoData.secretary_general">
          <div class="committee-label">사무총장</div>
          <div class="committee-value">{{ infoData.secretary_general }}</div>
        </div>

        <div class="committee-row" v-if="infoData.general_affairs">
          <div class="committee-label">총무이사</div>
          <div class="committee-value">{{ infoData.general_affairs }}</div>
        </div>

        <div class="committee-row mt-3" v-if="infoData.research_planning">
          <div class="committee-label">연구이사</div>
          <div class="committee-value">{{ infoData.research_planning }}</div>
        </div>

        <div class="committee-row" v-if="infoData.information">
          <div class="committee-label">정보이사</div>
          <div class="committee-value">{{ infoData.information }}</div>
        </div>

        <div class="committee-row mt-3" v-if="infoData.editing">
          <div class="committee-label">편집이사</div>
          <div class="committee-value">{{ infoData.editing }}</div>
        </div>

        <div class="committee-row" v-if="infoData.public_information">
          <div class="committee-label">홍보이사</div>
          <div class="committee-value">{{ infoData.public_information }}</div>
        </div>

        <div class="committee-row mt-3" v-if="infoData.international_cooperation">
          <div class="committee-label">국제협력이사</div>
          <div class="committee-value">{{ infoData.international_cooperation }}</div>
        </div>
      </div>

      <!-- 편집위원회 
      <div class="editorial-section" v-if="infoData.editorial_board_chair || infoData.editorial_board">
        <h2 class="editorial-title">국제한국어응용언어학회 편집위원회</h2>
        <div class="committee-table">
          <div class="committee-row" v-if="infoData.editorial_board_chair">
            <div class="committee-label">편집위원장</div>
            <div class="committee-value">{{ infoData.editorial_board_chair }}</div>
          </div>
          <div class="committee-row" v-if="infoData.editorial_board">
            <div class="committee-label">편집위원</div>
            <div class="committee-value">{{ infoData.editorial_board }}</div>
          </div>
        </div>
      </div>-->
    </div>

    <!-- 구분선 -->
    <hr class="divider" />

    <!-- 하단: 발행 정보 섹션 -->
    <div class="publication-section">
      <h2 class="journal-title-en">International Journal of Korean Applied Linguistics</h2>
      <p class="volume-info">Volume {{ journal.volume || '4' }} · December {{ displayYear }}</p>

      <div class="publication-table">
        <div class="pub-row">
          <div class="pub-label">Publisher</div>
          <div class="pub-value">The International Society of Korean Applied Linguistics (ISKAL)</div>
        </div>
        <div class="pub-row">
          <div class="pub-label">Place of Publication</div>
          <div class="pub-value">Department of Asian Languages and Literature, College of AI Humanities, Gachon University, 1342 Seongnam-daero, Sujeong-gu, Seongnam-si, Gyeonggi-do 13120, Republic of Korea</div>
        </div>
        <div class="pub-row">
          <div class="pub-label">Date of Publication</div>
          <div class="pub-value">{{ publicationDate }}</div>
        </div>
        <div class="pub-row">
          <div class="pub-label">Production and Distribution</div>
          <div class="pub-value">
            KONG & PARK, INC.<br />
            85, Gwangnaru-ro 56-gil, Prime Center #3411, Gwangjin-gu, Seoul 05116, Republic of Korea<br />
            Tel. +82-2-565-1531<br />
            E-mail: info@kongnpark.com
          </div>
        </div>
      </div>

      <p class="issn-info">ISSN: 2799-9106</p>
      <!--p class="doi-info">DOI:</p-->

      <hr class="thin-divider" />

      <p class="copyright-text">
        © {{ displayYear }} by The International Society of Korean Applied Linguistics (ISKAL).
      </p>
      <p class="copyright-notice">
        All rights reserved. No part of this journal may be reproduced, stored, or transmitted in any form or by any means without prior written permission of the copyright holder and the publisher.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "article-info-page",
  props: {
    item: {
      type: Object,
      required: false,
      default: () => {},
    },
    group: {
      type: Object,
      required: false,
      default: () => {},
    },
    journal: {
      type: Object,
      required: false,
      default: () => {},
    },
    startPageNumber: {
      type: Number,
      required: false,
      default: 1,
    },
    pageSize: {
      type: String,
      required: false,
      default: "A5",
    },
  },
  computed: {
    pageSizeClass() {
      return this.pageSize?.toLowerCase() || "a5";
    },
    infoData() {
      if (this.journal?.info_page_info) {
        try {
          return JSON.parse(this.journal.info_page_info);
        } catch (e) {
          return this.defaultData;
        }
      }
      return this.defaultData;
    },
    defaultData() {
      return {
        advisor: "김남길(USC), 신기현(UNSW), 이길원(동아대), 송향근(부산외대), 배재석(경희대)",
        advisory_committee: "",
        president: "강현화(연세대)",
        vice_president: "김경호(메지로대), 이상혁(한성대), 김정남(경희대), 윤영(호남대), 박석준(배재대), 최재준(가천대)",
        secretary_general: "홍혜란(배재대)",
        general_affairs: "김유미(서울과학종합대학원대학교), 장미경(성신여대), 홍연정(오사카공립대), 심란희(배재대)",
        research_planning: "김양진(경희대), 조참훈(서남대), 도원영(고려대)",
        information: "장준영(숭실사이버대), 김일환(성신여대), 전소희(메지로대), 이호은(청운대)",
        editing: "김강희(연세대), 조영보(메지로대), 강은지(부산대), 김의영(한밭대)",
        public_information: "이봉원(나사렛대), 김석영(한국교원대), 박진완(교토산요대), 유방혜숙(조지메이슨대)",
        international_cooperation: "이문화(중국화중사범대), 귁셀 튀르괴쥬(에르지예스대), 김선아(이공대), 김찬회(리쓰케이칸 아시아 태평양대), 김선효(문화대), 두루소(카포스카리 아메리칸대), 장석배(벤더빌트대), 안나 파라돕스카(바르샤바대), 한넬리(아블라이칸대), 신문경(리치몬드 아메리칸대)",
        editorial_board_chair: "김강희",
        editorial_board: "조영보(메지로대), 강은지(부산대), 김의영(한밭대)",
      };
    },
    displayMonth() {
      const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      const monthIndex = this.journal?.month
        ? parseInt(this.journal.month) - 1
        : new Date().getMonth();
      return months[monthIndex] || "December";
    },
    displayYear() {
      return this.journal?.year || new Date().getFullYear();
    },
    publicationDate() {
      const month = "December";
      const year = this.displayYear;
      const day = this.journal?.day || 31;
      return `${month} ${day}, ${year}`;
    },
  },
  mounted() {
    this.$emit("page-count", 1);
  },
};
</script>

<style lang="scss" scoped>
$primary-font-color: #231815;
$secondary-font-color: #666666;
$background-color: #ffffff;

// A4 패딩 (Journal Standard)
$a4-vertical-padding: 70px;
$a4-horizontal-padding: 70px;

// A5 패딩 (Journal Standard)
$a5-vertical-padding: 50px;
$a5-padding-left: 55px; // Binding Inner
$a5-padding-right: 35px; // Binding Outer

$sans-font-family: "Sandoll GtNeoCond", "Noto Sans KR", sans-serif;

$a4-width: 794px;
$a4-height: 1122px;
$a5-width: 559px;
$a5-height: 794px;

.page {
  background-color: $background-color;
  position: relative;
  box-sizing: border-box;
  height: auto;
  overflow: visible;
  page-break-before: always;
  page-break-after: always;

  &.a4 {
    width: $a4-width;
    min-height: $a4-height;
    padding: $a4-vertical-padding $a4-horizontal-padding;

    .committee-section {
      margin-bottom: 20px;
    }

    .society-title {
      font-size: 16px;
      margin-bottom: 20px;
    }

    .committee-label {
      font-size: 9px;
      min-width: 70px;
    }

    .committee-value {
      font-size: 9px;
    }

    .editorial-title {
      font-size: 11px;
    }

    .divider {
      margin: 20px 0;
    }

    .journal-title-en {
      font-size: 12px;
    }

    .volume-info {
      font-size: 10px;
    }

    .pub-label {
      font-size: 9px;
      min-width: 150px;
    }

    .pub-value {
      font-size: 9px;
    }

    .issn-info {
      font-size: 9px;
    }

    .copyright-text,
    .copyright-notice {
      font-size: 8px;
    }
  }

  &.a5 {
    width: $a5-width;
    min-height: $a5-height;
    padding: $a5-vertical-padding $a5-padding-right $a5-vertical-padding $a5-padding-left;

    .committee-section {
      margin-bottom: 12px;
    }

    .society-title {
      font-size: 12px;
      margin-bottom: 12px;
      padding-bottom: 6px;
    }

    .committee-table {
      margin-bottom: 10px;
    }

    .committee-row {
      margin-bottom: 4px;
    }

    .committee-label {
      font-size: 7px;
      min-width: 50px;
    }

    .committee-value {
      font-size: 7px;
      line-height: 1.8;
    }

    .mt-3 {
      margin-top: 8px;
    }

    .editorial-section {
      margin-top: 12px;
    }

    .editorial-title {
      font-size: 8px;
      margin-bottom: 6px;
    }

    .divider {
      margin: 12px 0;
    }

    .thin-divider {
      margin: 10px 0;
    }

    .journal-title-en {
      font-size: 9px;
    }

    .volume-info {
      font-size: 8px;
      margin-bottom: 10px;
    }

    .publication-table {
      margin-bottom: 10px;
    }

    .pub-row {
      margin-bottom: 5px;
    }

    .pub-label {
      font-size: 7px;
      min-width: 100px;
    }

    .pub-value {
      font-size: 7px;
      line-height: 1.8;
    }

    .issn-info {
      font-size: 7px;
    }

    .copyright-text,
    .copyright-notice {
      font-size: 6px;
      line-height: 1.8;
    }
  }
}

/** ****************************************************************************************
 * [ 임원 정보 섹션 ]
 *******************************************************************************************/
.committee-section {
  margin-bottom: 20px;
}

.society-title {
  font-family: $sans-font-family;
  font-size: 16px;
  font-weight: 700;
  color: $primary-font-color;
  text-align: center;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid $primary-font-color;
}

.committee-table {
  margin-bottom: 15px;
}

.committee-row {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  margin-bottom: 6px;
}

.committee-label {
  font-family: $sans-font-family;
  font-size: 9px;
  font-weight: 700;
  color: $primary-font-color;
  min-width: 70px;
  flex-shrink: 0;
  line-height: 2;
}

.committee-value {
  font-family: $sans-font-family;
  font-size: 9px;
  font-weight: 400;
  color: $primary-font-color;
  line-height: 2;
  flex: 1;
}

.mt-3 {
  margin-top: 12px;
}

/** ****************************************************************************************
 * [ 편집위원회 섹션 ]
 *******************************************************************************************/
.editorial-section {
  margin-top: 20px;
}

.editorial-title {
  font-family: $sans-font-family;
  font-size: 11px;
  font-weight: 700;
  color: $primary-font-color;
  margin: 0 0 10px 0;
}

/** ****************************************************************************************
 * [ 구분선 ]
 *******************************************************************************************/
.divider {
  border: none;
  border-top: 1px solid $primary-font-color;
  margin: 20px 0;
}

.thin-divider {
  border: none;
  border-top: 1px solid #cccccc;
  margin: 15px 0;
}

/** ****************************************************************************************
 * [ 발행 정보 섹션 ]
 *******************************************************************************************/
.publication-section {
  padding: 0;
}

.journal-title-en {
  font-family: $sans-font-family;
  font-size: 12px;
  font-weight: 700;
  color: $primary-font-color;
  margin: 0 0 5px 0;
}

.volume-info {
  font-family: $sans-font-family;
  font-size: 10px;
  font-weight: 400;
  color: $primary-font-color;
  margin: 0 0 15px 0;
}

.publication-table {
  margin-bottom: 15px;
}

.pub-row {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  margin-bottom: 8px;
}

.pub-label {
  font-family: $sans-font-family;
  font-size: 9px;
  font-weight: 700;
  color: $primary-font-color;
  min-width: 150px;
  flex-shrink: 0;
  line-height: 2;
}

.pub-value {
  font-family: $sans-font-family;
  font-size: 9px;
  font-weight: 400;
  color: $primary-font-color;
  line-height: 2;
  flex: 1;
}

.issn-info,
.doi-info {
  font-family: $sans-font-family;
  font-size: 9px;
  font-weight: 400;
  color: $primary-font-color;
  margin: 0 0 3px 0;
}

.copyright-text {
  font-family: $sans-font-family;
  font-size: 8px;
  font-weight: 400;
  color: $secondary-font-color;
  margin: 0 0 5px 0;
}

.copyright-notice {
  font-family: $sans-font-family;
  font-size: 8px;
  font-weight: 400;
  color: $secondary-font-color;
  margin: 0;
  line-height: 1.4;
}
</style>
